import React, { useEffect } from "react";
import { Table } from "antd";
import {formatNumberEuropean} from "../../../utils/numberUtil";

const twoPointDecimal = (number) => Number(number).toFixed(2);

const RecapitulationTable = ({recapitulationData}) => {
    return (
        <span onClick={(e) => { e.preventDefault(); e.stopPropagation() }}  >
            <Table
                bordered
                style={{
                    wordBreak: "break-all",
                    width: "100%",
                    tableLayout: "fixed",
                }}
                pagination={false}
                columns={[
                    {
                        title: "Dogovoreni iznos",
                        dataIndex: "agreedPrice",
                        render: (value => (<>{formatNumberEuropean(value)} €</>))
                    },
                    {
                        title: "Ukupni troškovi",
                        dataIndex: "totalExpenses",
                        render: (value => (<>{formatNumberEuropean(value)} €</>))
                    },
                    {
                        title: "Trenutne uplate",
                        dataIndex: "totalPayments",
                        render: (value => (<>{formatNumberEuropean(value)} €</>))
                    },
                    {
                        title: "Trenutna dobit",
                        dataIndex: "currentProfit",
                        render: (value => (<>{formatNumberEuropean(value)} €</>))
                    },
                    {
                        title: "Planirana dobit",
                        dataIndex: "plannedProfit",
                        render: (value => (<>{formatNumberEuropean(value)} €</>))
                    },
                ]}
                dataSource={[].concat(recapitulationData)}
                size="small"
                scroll={{x: 700}}
            />
        </span>);
}
export default RecapitulationTable;